/**
 * Product Features Hotspot
 * Interactive hotspot highlighting between image markers and feature list
 */

class ProductFeaturesHotspot extends HTMLElement {
  constructor() {
    super();
    this.features = this.querySelectorAll('.product-features-hotspot__feature');
    this.hotspots = this.querySelectorAll('.product-features-hotspot__hotspot');
    this.activeIndex = null;
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.init();
  }

  init() {
    // Add hover listeners to features
    this.features.forEach((feature, index) => {
      feature.addEventListener('mouseenter', () => this.highlightPair(index + 1));
      feature.addEventListener('mouseleave', () => this.clearHighlight());
      feature.addEventListener('click', () => this.toggleHighlight(index + 1));
    });

    // Add hover listeners to hotspots
    this.hotspots.forEach((hotspot, index) => {
      hotspot.addEventListener('mouseenter', () => this.highlightPair(index + 1));
      hotspot.addEventListener('mouseleave', () => this.clearHighlight());
      hotspot.addEventListener('click', () => this.toggleHighlight(index + 1));
    });

    document.addEventListener('click', this.handleOutsideClick);
  }

  highlightPair(index) {
    // Dim all features and hotspots
    this.features.forEach(f => f.classList.add('dimmed'));
    this.hotspots.forEach(h => h.classList.add('dimmed'));

    // Highlight the matching pair
    const activeFeature = this.querySelector(`.product-features-hotspot__feature[data-feature="${index}"]`);
    const activeHotspot = this.querySelector(`.product-features-hotspot__hotspot[data-hotspot="${index}"]`);

    if (activeFeature) activeFeature.classList.remove('dimmed');
    if (activeHotspot) activeHotspot.classList.remove('dimmed');
  }

  clearHighlight() {
    if (this.activeIndex !== null) return;

    this.features.forEach(f => f.classList.remove('dimmed'));
    this.hotspots.forEach(h => h.classList.remove('dimmed'));
  }

  toggleHighlight(index) {
    if (this.activeIndex === index) {
      this.activeIndex = null;
      this.features.forEach(f => f.classList.remove('dimmed'));
      this.hotspots.forEach(h => h.classList.remove('dimmed'));
      return;
    }

    this.activeIndex = index;
    this.highlightPair(index);
  }

  handleOutsideClick(event) {
    if (this.contains(event.target)) return;

    this.activeIndex = null;
    this.features.forEach(f => f.classList.remove('dimmed'));
    this.hotspots.forEach(h => h.classList.remove('dimmed'));
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleOutsideClick);
  }
}

if (!customElements.get('product-features-hotspot')) {
  customElements.define('product-features-hotspot', ProductFeaturesHotspot);
}
